import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as dotMailerTrackActions from './store/actions/dot-mailer-tracker-actions';
import FormSpinner from '../../sso/components/common/utility/FormSpinner';
import { getFormattedIntegerValues } from './utils/number-utils';

class DotMailerTrackerForm extends Component {
    constructor(props) {
        super(props);

        this.dropZoneRef = React.createRef();
        this.fileUploadInputRef = React.createRef();

        this.handleCSVFileDrop = this.handleCSVFileDrop.bind(this);
        this.processCSVFile = this.processCSVFile.bind(this);
        this.handleCSVFileRead = this.handleCSVFileRead.bind(this);
        this.finalizeCSVFileProcess = this.finalizeCSVFileProcess.bind(this);
        this.finalizeCSVFileProcessWithErrors = this.finalizeCSVFileProcessWithErrors.bind(this);
        this.handleDotMailerUserEntriesSubmit = this.handleDotMailerUserEntriesSubmit.bind(this);
        this.toggleOnDragClass = this.toggleOnDragClass.bind(this);
        this.handleOnDragOver = this.handleOnDragOver.bind(this);
        this.handleDropZoneClick = this.handleDropZoneClick.bind(this);

        this.initialState = {
            isDragOverDropZone: false,
            isCSVFileDataLoaded: false,
            csvFileLoadError: false,
            csvFileLoadErrorMessage: '',
            dotMailerUserEntries: [],
            dotMailerUserEntriesLength: 0,
            fileName: ''
        };

        this.state = this.initialState;
    }

    handleCSVFileDrop(event) {
        event.preventDefault();
        event.stopPropagation();
        const files = event.dataTransfer === undefined ||
            _.isEmpty(event.dataTransfer.files) ?
            event.target.files :
            event.dataTransfer.files;

        this.processCSVFile(files);
    }

    processCSVFile(files) {
        const shouldProcessFiles = !_.isEmpty(files) && files.length === 1;

        if (!shouldProcessFiles) {
            this.finalizeCSVFileProcessWithErrors('Please load just one CSV file.');
            return;
        }

        const file = files[0];
        const fileName = file.name;
        const fileExtension = this.getFileExtension(fileName);
        if (fileExtension !== 'csv') {
            this.finalizeCSVFileProcessWithErrors('The fie loaded has an invalid extension.');
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => this.handleCSVFileRead(event, fileName, reader);

        reader.readAsText(file);
    }

    handleCSVFileRead(event, fileName, reader) {
        const csvFileLines = reader.result.split('\n').filter((csvFileLine) => !_.isEmpty(csvFileLine));

        const dotMailerUserEntries = csvFileLines.map((csvFileLine) => {
            const dotMailerEntry = csvFileLine.split(',');

            if (_.isEmpty(dotMailerEntry) || dotMailerEntry.length !== 2) {
                return { email: '', addressBookId: '' };
            }

            return { email: dotMailerEntry[0], addressBookId: dotMailerEntry[1] };
        });

        this.finalizeCSVFileProcess(dotMailerUserEntries, fileName);
    }

    getFileExtension(filename) {
        return filename.split('.').pop();
    }

    finalizeCSVFileProcess(dotMailerUserEntries, fileName) {
        this.setState(() => ({
            isDragOverDropZone: false,
            isCSVFileDataLoaded: true,
            csvFileLoadError: false,
            csvFileLoadErrorMessage: '',
            dotMailerUserEntries,
            dotMailerUserEntriesLength: dotMailerUserEntries.length,
            fileName
        }));
    }

    finalizeCSVFileProcessWithErrors(csvFileLoadErrorMessage) {
        this.setState(() => ({
            isDragOverDropZone: false,
            isCSVFileDataLoaded: false,
            csvFileLoadError: true,
            csvFileLoadErrorMessage,
            dotMailerUserEntries: [],
            dotMailerUserEntriesLength: 0,
            fileName: ''
        }));
    }

    handleDotMailerUserEntriesSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        const { dotMailerUserEntries } = this.state;
        const { actions, dotMailerTrackerProperties } = this.props;
        const { callBackUrl } = dotMailerTrackerProperties;
        actions.submitDotMailerTrackData(dotMailerUserEntries, callBackUrl);
    }

    toggleOnDragClass(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setState((prevState) => ({
            isDragOverDropZone: !prevState.isDragOverDropZone
        }));
    }

    handleOnDragOver(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    handleDropZoneClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.fileUploadInputRef.current.click();
    }

    render() {
        const {
            isDragOverDropZone,
            fileName,
            isCSVFileDataLoaded,
            dotMailerUserEntriesLength,
            csvFileLoadError,
            csvFileLoadErrorMessage
        } = this.state;

        const { loading, areDotMailerEntriesLoadedSuccessfully, dotMailerTrackerApiMessage } = this.props;

        return (
            <Fragment>
                {loading && <FormSpinner></FormSpinner>}
                <h2 className={`file-process-message ${areDotMailerEntriesLoadedSuccessfully ? 'file-process-success-message' : 'file-process-error-message'}`}>
                    {dotMailerTrackerApiMessage}
                </h2>
                {csvFileLoadError &&
                    <h2 className='file-process-message file-process-error-message'>{csvFileLoadErrorMessage} </h2>}

                <input type='file'
                    ref={this.fileUploadInputRef}
                    onChange={this.handleCSVFileDrop}
                    className='file-upload-input button button--primary'
                />
                <div className={`file-drop-zone ${isDragOverDropZone ? 'file-drag-enter' : ''}`}
                    ref={this.dropZoneRef}
                    onDragEnter={this.toggleOnDragClass}
                    onDragLeave={this.toggleOnDragClass}
                    onDragOver={this.handleOnDragOver}
                    onDrop={this.handleCSVFileDrop}
                    onClick={this.handleDropZoneClick}>
                    <h2>{'Drag DotMailer CSV file here.'}</h2>
                </div>
                {isCSVFileDataLoaded &&
                    <div>
                        <h2 className='file-process-message'>{getFormattedIntegerValues(dotMailerUserEntriesLength)} entries from {fileName} have been processed</h2>
                        <button className='button button--primary' onClick={this.handleDotMailerUserEntriesSubmit}> SUBMIT {getFormattedIntegerValues(dotMailerUserEntriesLength)} entries</button>
                    </div>}
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        areDotMailerEntriesLoadedSuccessfully: state.dotMailerTracker.areDotMailerEntriesLoadedSuccessfully,
        dotMailerTrackerApiMessage: state.dotMailerTracker.dotMailerTrackerApiMessage,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            submitDotMailerTrackData: bindActionCreators(dotMailerTrackActions.submitDotMailerTrackData, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DotMailerTrackerForm);
